import { render, staticRenderFns } from "./LevelLabel.vue?vue&type=template&id=70feb516&"
import script from "./LevelLabel.vue?vue&type=script&lang=ts&"
export * from "./LevelLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports